import _ from '@luna/lodash';
import type { COUNTRY } from '@shared/core-types';

import type {
    SharedShorthandTransactionsFeatures,
    SharedTransactionsFeatures,
} from '../types/SharedTransactionsFeatures';
import { features as base, shorthandFeatures as baseShorthand } from './base';
import { features as AT, shorthandFeatures as shorthandFeaturesAT } from './countries/AT';
import { features as CZ, shorthandFeatures as shorthandFeaturesCZ } from './countries/CZ';
import { features as HR, shorthandFeatures as shorthandFeaturesHR } from './countries/HR';
import { features as HU, shorthandFeatures as shorthandFeaturesHU } from './countries/HU';
import { features as RO, shorthandFeatures as shorthandFeaturesRO } from './countries/RO';
import { features as SK, shorthandFeatures as shorthandFeaturesSK } from './countries/SK';
import { features as RS, shorthandFeatures as shorthandFeaturesRS } from './countries/RS';

export const features: Record<COUNTRY, SharedTransactionsFeatures> = {
    AT: _.merge({}, base, AT),
    CZ: _.merge({}, base, CZ),
    HR: _.merge({}, base, HR),
    HU: _.merge({}, base, HU),
    RO: _.merge({}, base, RO),
    SK: _.merge({}, base, SK),
    RS: _.merge({}, base, RS),
};

export const shorthandFeatures: Record<COUNTRY, SharedShorthandTransactionsFeatures> = {
    AT: _.merge({}, baseShorthand, shorthandFeaturesAT),
    CZ: _.merge({}, baseShorthand, shorthandFeaturesCZ),
    HR: _.merge({}, baseShorthand, shorthandFeaturesHR),
    HU: _.merge({}, baseShorthand, shorthandFeaturesHU),
    RO: _.merge({}, baseShorthand, shorthandFeaturesRO),
    SK: _.merge({}, baseShorthand, shorthandFeaturesSK),
    RS: _.merge({}, baseShorthand, shorthandFeaturesRS),
};
